import { whenElse } from '@genesislcap/foundation-utils';
import { html, slotted, when } from '@microsoft/fast-element';
import { TabsOrientation } from '@microsoft/fast-foundation';
import { getPrefix } from '../utils';
export const getPrefixedStepper = (prefix) => html `
  <${prefix}-card class="stepper-tab" part="stepper-tab" role="stepper-tab" data-test-id="stepper-tab">
    <div class="stepper-tab-menu" part="stepper-tab-menu">
      <slot name="tab" ${slotted('tabs')}></slot>
    </div>
    ${when((x) => x.orientation === TabsOrientation.vertical, html `
        <div class="stepper-tab-progress" part="stepper-tab-progress">
          <${prefix}-progress-ring class="progress-ring" part="progress-ring" value=${(x) => x.progressValue}></${prefix}-progress-ring>
          <label>You have completed ${(x) => x.progressValue}% of the fields required to create a project</label>
        </div>`)}
  </${prefix}-card>
  <${prefix}-card class="stepper-tab-panel" part="stepper-tab-panel" data-test-id="stepper-tab-panel">
    <div class="stepper-panel-container" part="stepper-panel-container">
      <slot name="tab-panel" ${slotted('tabpanels')}></slot>
    </div>
    <div class="action-buttons-container" part="action-buttons-container">
      <slot name="action-buttons">
        <${prefix}-button @click=${(x) => x.previousStep()} ?disabled=${(x) => x.disabledPreviousStep}>Back</${prefix}-button>
          ${whenElse((x) => x.isLastStep, html `
              <${prefix}-button @click=${(x) => x._submit()} ?disabled=${(x) => x.islastStepValid} data-test-id="submit-button">
                Submit
              </${prefix}-button>
            `, html `
              <${prefix}-button @click=${(x) => x.nextStep()} data-test-id="next-button">Next</${prefix}-button>
            `)}
      </slot>
    </div>
  </${prefix}-card>
`;
export const foundationStepperTemplate = html `
  ${(x) => getPrefixedStepper(getPrefix(x))}
`;
